import React, { useEffect, useState } from "react";
import './BackToTop.css';

const BackToTop = () => {
  const [show, setShow] = useState(false);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setPercent(scrolled);
      setShow(scrollTop > 50);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const circumference = 307.919;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <div
      className={`scroll-top ${show ? "show" : ""}`}
      onClick={scrollTop}
    >
      <svg
        className="progress-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            transition: "none",
            strokeDasharray: "307.919, 307.919",
            strokeDashoffset: offset
          }}
        />
      </svg>
      {/* Hand-drawn SVG arrow instead of FontAwesome to prevent the square box rendering error */}
      <svg
        className="arrow-icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="19" x2="12" y2="5"></line>
        <polyline points="5 12 12 5 19 12"></polyline>
      </svg>
    </div>
  );
};

export default BackToTop;
